














import { State, Action } from "vuex-class";
import { Component, Vue } from "vue-property-decorator";

/**
 * Types
 */
import { SnackbarType } from "./SnackbarType";
import { SnackbarState } from "./store";

const namespace = "snackbar";

/**
 * Composant de Toast.
 */
@Component
export default class Snackbar extends Vue {
	snackbarType = SnackbarType;

	get show() {
		return this.state.show;
	}

	set show(value) {
		this.close();
	}

	/// VueX - Snackbar
	@State(namespace) state!: SnackbarState;
	@Action("close", { namespace }) close: any;
}
